const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-v2';
const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js?render=explicit';
const READY_RETRY_DELAY = 100;
const READY_RETRY_LIMIT = 50;

let loadingPromise;

const waitForRecaptcha = (resolve, reject, attempt) => {
  if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
    resolve(window.grecaptcha);
    return;
  }

  if (attempt >= READY_RETRY_LIMIT) {
    reject(new Error('reCAPTCHA failed to load'));
    return;
  }

  window.setTimeout(() => waitForRecaptcha(resolve, reject, attempt + 1), READY_RETRY_DELAY);
};

export const loadRecaptcha = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('reCAPTCHA requires a browser environment'));
  }

  if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
    return Promise.resolve(window.grecaptcha);
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(RECAPTCHA_SCRIPT_ID);

    if (existingScript) {
      waitForRecaptcha(resolve, reject, 0);
      return;
    }

    const script = document.createElement('script');
    script.id = RECAPTCHA_SCRIPT_ID;
    script.src = RECAPTCHA_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => waitForRecaptcha(resolve, reject, 0);
    script.onerror = () => reject(new Error('reCAPTCHA failed to load'));

    document.head.appendChild(script);
  }).catch((error) => {
    loadingPromise = null;
    throw error;
  });

  return loadingPromise;
};

export default {
  loadRecaptcha,
};



// WEBPACK FOOTER //
// ./src/utils/recaptcha.js